import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../Button/Button'
import { cx } from '../utils/cx'
import './CartBar.css'

export interface CartBarProps {
  /** Número de extras elegidos; con 0 no se muestra */
  count: number
  /** Total formateado, p. ej. "81,00 €" */
  total: ReactNode
  onPay: () => void
  /** Texto del botón; por defecto "Pagar {total}". Con la API actual el cobro no es en la app (D46): "Continuar" */
  actionLabel?: ReactNode
  loading?: boolean
  /** Pegada sobre la navegación inferior (bottom: 64 px) */
  sticky?: boolean
  className?: string
}

/** Barra de carrito (bundle B6): fija sobre la navegación, elevación 1, recuento + total + botón primario con importe. */
export function CartBar({ count, total, onPay, actionLabel, loading, sticky = true, className }: CartBarProps) {
  const { t } = useTranslation()
  if (count <= 0) return null
  return (
    <div className={cx('hp-cartbar', sticky && 'hp-cartbar--sticky', className)} role="region" aria-label={t('v2.ds.cartBar.extras', { count })}>
      <div>
        <div className="hp-cartbar__count">{t('v2.ds.cartBar.extras', { count })}</div>
        <div className="hp-cartbar__total tnum">{total}</div>
      </div>
      <Button variant="primary" fullWidth={false} onClick={onPay} loading={loading ?? false}>
        {actionLabel ?? (
          <>
            {t('v2.ds.cartBar.pagar')} <span className="tnum">{total}</span>
          </>
        )}
      </Button>
    </div>
  )
}
